module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/hall-list/plan-ceremony-lineup-tokai-4-b4e87594ea17cbfcea42f1a40e95c14c.png";